var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('titan-alerts',{attrs:{"i18n":_vm.t}}),(_vm.$store.state.translate.loading === false)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }